import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Only initialize Stripe if we have a valid publishable key
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

export { stripePromise };

// Stripe configuration
export const STRIPE_CONFIG = {
  // QME Ratings subscription plans
  PLANS: {
    FREE: {
      name: 'QME Ratings Free',
      price: 0,
      priceId: null, // No Stripe price ID for free tier
      features: [
        '25 AI processing sessions per month',
        '3 manual input sessions per month',
        'All body region calculations',
        'Professional narratives',
        'Basic support'
      ],
      limits: {
        aiSessions: 25,
        manualSessions: 3
      }
    },
    PREMIUM: {
      name: 'QME Ratings Premium',
      price: 100, // Monthly price in USD
      priceId: process.env.REACT_APP_STRIPE_PREMIUM_PRICE_ID, // Will be set after creating in Stripe
      features: [
        'Unlimited AI processing sessions',
        'Unlimited manual input sessions',
        'All body region calculations',
        'Professional narratives',
        'Priority support',
        'Advanced analytics',
        'Export capabilities'
      ],
      limits: {
        aiSessions: -1, // -1 means unlimited
        manualSessions: -1 // -1 means unlimited
      }
    }
  }
};

// Helper function to get plan details by subscription tier
export const getPlanByTier = (tier: 'free' | 'premium') => {
  return tier === 'premium' ? STRIPE_CONFIG.PLANS.PREMIUM : STRIPE_CONFIG.PLANS.FREE;
};

// Helper function to check if user has unlimited access
export const hasUnlimitedAccess = (tier: 'free' | 'premium') => {
  return tier === 'premium';
};
